"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSignPostButton = exports.StyledSignPostButtonClose = exports.StyledSignPost = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const buttonReset_styles_1 = require("../DesignSystem/styles/buttonReset.styles");
const helpers_1 = require("../helpers");
const SignPostView_1 = require("./types/SignPostView");
const getColorByView = ({ view, theme, color }) => {
    if (color) {
        return color;
    }
    switch (view) {
        case SignPostView_1.SIGN_POST_VIEW.info:
            return theme === null || theme === void 0 ? void 0 : theme.colorStripeAccent;
        case SignPostView_1.SIGN_POST_VIEW.error:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderError;
        case SignPostView_1.SIGN_POST_VIEW.warning:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderWarning;
        default:
            return theme === null || theme === void 0 ? void 0 : theme.colorBorderSuccess;
    }
};
exports.StyledSignPost = styled_components_1.default.div `
    box-sizing: border-box;
    ${({ theme }) => (0, styled_components_1.css) `
        padding: ${theme.spacing.s} ${theme.spacing.s} ${theme.spacing.s}
            calc(${theme.spacing.s} + ${theme.spacing.xs});
        background: ${theme.colorBackgroundBlank};
        border: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderMain};
    `};

    ${({ width, useMaxWidth, theme }) => (0, styled_components_1.css) `
            ${useMaxWidth ? 'max-width' : 'width'}: ${width !== null && width !== void 0 ? width : theme.sizes.fields.xl};
        `};
    position: relative;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.25);

    &::after {
        content: '';
        position: absolute;
        ${({ theme }) => (0, styled_components_1.css) `
            background: ${theme.colorStripeAccent};
            width: ${theme.spacing.xs};
        `};
        ${({ view, color, theme }) => (0, styled_components_1.css) `
            background: ${getColorByView({ view, theme, color })};
        `};
        top: 0;
        left: 0;
        bottom: 0;
    }
`;
exports.StyledSignPostButtonClose = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${helpers_1.SPACING_M};
    width: ${helpers_1.SPACING_M};
    cursor: pointer;

    ${({ theme }) => (0, styled_components_1.css) `
        margin-left: ${theme.spacing.s};

        &:hover {
            background: ${theme.colorHighlightLight};
        }

        &:active {
            background: ${theme.colorHighlightDark};
        }
    `}
`;
exports.StyledSignPostButton = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    flex-shrink: 0;
    display: inline-flex;
    cursor: pointer;
`;
//# sourceMappingURL=SignPost.styles.js.map